export default "__VITE_ASSET__eb49XgR7__"